document.addEventListener("DOMContentLoaded", () => {
  // Garante que o body começa com scroll liberado (caso algum script tenha travado)
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.documentElement.style.overflowY = '';
  document.documentElement.style.overflowX = 'hidden';

  /* =================== */
  /* SWIPER CAROUSELS    */
  /* =================== */
  document.querySelectorAll('.products-swiper').forEach(el => {
    new Swiper(el, {
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: { slidesPerView: 1.2 },
        480: { slidesPerView: 2 },
        768: { slidesPerView: 2.5 },
        1024: { slidesPerView: 3.5 },
        1280: { slidesPerView: 4 }
      }
    });
  });

  /* =================== */
  /* STICKY HEADER       */
  /* =================== */
  const header = document.querySelector('.header');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', () => {
      const current = window.scrollY;

      if (current > lastScroll && current > 100) {
        header.style.transform = "translateY(-100%)";
      } else {
        header.style.transform = "translateY(0)";
      }

      lastScroll = current;
    });
  }

  /* =================== */
  /* SCROLL REVEAL       */
  /* =================== */
  const reveals = document.querySelectorAll('.reveal');

  function checkReveal() {
    reveals.forEach(el => {
      const top = el.getBoundingClientRect().top;
      if (top < window.innerHeight - 100) {
        el.classList.add('active');
      }
    });
  }

  window.addEventListener('scroll', checkReveal);
  checkReveal();

  /* =================== */
  /* COUNTDOWN           */
  /* =================== */
  document.querySelectorAll('.countdown').forEach(el => {
    const end = new Date(el.dataset.time).getTime();

    if (end > Date.now()) {
      setInterval(() => {
        const now = new Date().getTime();
        const diff = end - now;

        if (diff <= 0) {
          el.innerHTML = "ENCERRADO";
          return;
        }

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);

        el.innerHTML = d > 0 ? `${d}d ${h}h ${m}m ${s}s` : `${h}h ${m}m ${s}s`;
      }, 1000);
    }
  });

  /* =================== */
  /* DRAG SCROLL         */
  /* =================== */
  document.querySelectorAll('.categories-scroll').forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.style.cursor = 'grab';
  });

});
